// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__GkEoC","tabContainer":"Navbar_tabContainer__ZB4V3","start":"Navbar_start__xSUTT"};